module.exports = __webpack_public_path__ + "img/covid-dark.45041beb.svg";